export default __webpack_public_path__ + "static/media/unionpay.5f333499.svg";